import React from "react";
import { Button, message } from "antd";
import { CopyOutlined } from "@ant-design/icons";


const rowStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "3px 0",
  gap: "1rem",
};

const labelStyle = { color: "#64748b", fontSize: 13, whiteSpace: "nowrap" };

const valueStyle = {
  fontFamily: "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace",
  fontWeight: 600,
  fontSize: 13,
  color: "#0f172a",
  wordBreak: "break-all",
  textAlign: "right",
};

const highlightStyle = {
  ...valueStyle,
  background: "#fef9c3",
  border: "1px solid #fde68a",
  padding: "1px 8px",
  borderRadius: 4,
};

const sectionStyle = {
  background: "#f8fafc",
  border: "1px solid #e2e8f0",
  borderRadius: 8,
  padding: "10px 14px",
  marginTop: 10,
};

const sectionTitleStyle = {
  fontSize: 11,
  fontWeight: 700,
  letterSpacing: "0.06em",
  color: "#94a3b8",
  textTransform: "uppercase",
  marginBottom: 6,
};

const Row = ({ label, value, highlight }) => (
  <div style={rowStyle}>
    <span style={labelStyle}>{label}</span>
    <span style={highlight ? highlightStyle : valueStyle}>{value}</span>
  </div>
);

const CredentialsCard = ({ note, student, parent }) => {
  const copyCredentials = () => {
    const lines = [
      `Student ID: ${student?.unique_id || ""}`,
      `Student username: ${student?.username || ""}`,
      `Student password: ${student?.password || ""}`,
      `Parent username: ${parent?.username || ""}`,
      parent?.password
        ? `Parent password: ${parent.password}`
        : "Parent password: (existing account — unchanged)",
    ];
    const text = lines.join("\n");
    if (navigator.clipboard?.writeText) {
      navigator.clipboard
        .writeText(text)
        .then(() => message.success("Credentials copied"))
        .catch(() => message.error("Could not copy — select and copy manually"));
    } else {
      message.error("Could not copy — select and copy manually");
    }
  };

  return (
    <div>
      {note && <p style={{ marginBottom: 4 }}>{note}</p>}

      <div style={sectionStyle}>
        <div style={sectionTitleStyle}>Student</div>
        <Row label="ID" value={student?.unique_id} />
        <Row label="Username" value={student?.username} />
        <Row label="Password" value={student?.password} highlight />
      </div>

      <div style={sectionStyle}>
        <div style={sectionTitleStyle}>Parent</div>
        {parent?.name && <Row label="Name" value={parent.name} />}
        <Row label="Username" value={parent?.username} />
        {parent?.password ? (
          <Row label="Password" value={parent.password} highlight />
        ) : (
          <div style={{ color: "#64748b", fontSize: 12, paddingTop: 4 }}>
            Existing parent account reused — their current login still works.
          </div>
        )}
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginTop: 12,
          gap: "0.5rem",
        }}
      >
        <span style={{ color: "#94a3b8", fontSize: 12 }}>
          Shown only once — share with the family now.
        </span>
        <Button size="small" icon={<CopyOutlined />} onClick={copyCredentials}>
          Copy
        </Button>
      </div>
    </div>
  );
};

export default CredentialsCard;
